export enum MarketplaceFormType {
  GIFT = 'gift',
  E_COMMERCE = 'e-commerce',
  URL_TRACKING = 'url-tracking',
  SOCIAL_MEDIA_TRACKING = 'social-media-tracking',
  REFERRAL_CODE_TRACKING = 'referral-code-tracking'
}
